import Button from 'components/_UI/Button'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import React from 'react'
import colors from 'theme/colors'

export default function TeamInviteAlert({ visible, data, onClose }) {

    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            {
                data?.type == 'accept' && (
                    <>
                        <Text name='normal' type='bold' color={colors.successLight}>
                            Convite aceito
                        </Text>

                        <Text color={colors.night}>
                            Parabéns! Agora você faz parte da equipe <b>"{data?.teamName}"</b> e já pode acessar o que foi liberado pra ela aqui embaixo.
                        </Text>

                        <Button
                            variant='lightBlue'
                            category='roundedBorded'
                            marginTop={'16px'}
                            onClick={onClose}
                        >
                            Acessar painel
                        </Button>
                    </>
                )
            }

            {
                data?.type == 'reject' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Convite recusado
                        </Text>

                        <Text color={colors.night}>
                            Você recusou o convite para entrar na equipe <b>"{data?.teamName}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'error' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Ocorreu um erro
                        </Text>

                        <Text color={colors.night}>
                            Ocorreu um erro inesperado durante o seu convite, entre em contato com o responsável da equipe.
                        </Text>
                    </>
                )
            }
        </Modal>
    )
}
